import { defineStore } from 'pinia'
import {
  createNoteAPI,
  loadNotesAPI,
  updateNoteAPI,
  deleteNoteAPI
} from '@/services/teams-service'
import { requestTypes } from '@/constants/request-types'
import uuid from '@/helpers/uuid'

export const useNotesStore = defineStore('notes-store', {
  state: () => ({
    error: {},
    loading: {},
    createOrUpdateNoteLoading: false,
    notes: []
  }),
  getters: {
    getNote:
      (state) =>
      ({ noteName }) => {
        return state.notes.find((n) => n.name === noteName)
      }
  },
  actions: {
    clear() {
      this.error = {}
      this.loading = {}
      this.notes = []
    },
    addOrReplaceNote(note) {
      try {
        const noteExists =
          this.notes && this.notes.find((n) => n.name === note.name)

        if (noteExists) {
          this.notes = this.notes.map((existingNote) => {
            if (existingNote.name === note.name) {
              return note
            }
            return existingNote
          })
        } else {
          this.notes = (this.notes || []).concat(note)
        }
      } catch (error) {
        this.error = error
        throw error
      }
    },
    async deleteNoteAction({ teamName, surveyName, noteName }) {
      this.createOrUpdateNoteLoading = true
      const currentNote = this.getNote({ noteName })
      try {
        this.notes = this.notes.filter(
          (existingNote) => existingNote.name !== noteName
        )
        await deleteNoteAPI({
          surveyName,
          teamName,
          noteName
        })
      } catch (error) {
        this.addOrReplaceNote(currentNote)
        this.error = error
        throw error
      } finally {
        this.createOrUpdateNoteLoading = false
      }
    },
    async loadSurveyNotesAction({ teamName, surveyName }) {
      this.loading[requestTypes.NOTES] = true
      try {
        const notes = await loadNotesAPI({
          teamName,
          surveyName
        })
        this.notes = notes
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.loading[requestTypes.NOTES] = false
      }
    },
    createInitialSurveyNoteAction({ username }) {
      try {
        const note = {
          name: uuid(), // generate unique id
          initial: true, // so we know this needs to be saved
          value: '',
          from: username,
          to: []
        }
        this.addOrReplaceNote(note)
      } catch (error) {
        this.error = error
        throw error
      }
    },
    async createSurveyNoteAction({
      teamName,
      surveyName,
      noteText,
      username,
      noteName,
      to
    }) {
      try {
        this.createOrUpdateNoteLoading = true
        const note = {
          name: noteName,
          value: noteText,
          from: username,
          to
        }
        const newNote = await createNoteAPI({
          surveyName,
          teamName,
          note
        })
        this.addOrReplaceNote(newNote)
      } catch (error) {
        this.error = error
        throw error
        this.addOrReplaceNote(note)
      } finally {
        this.createOrUpdateNoteLoading = false
      }
    },

    async updateSurveyNoteAction({
      surveyName,
      teamName,
      noteName,
      noteText,
      to
    }) {
      this.createOrUpdateNoteLoading = true
      const currentNote = this.getNote({ noteName })
      try {
        const updatedNote = {
          ...currentNote,
          value: noteText,
          to
        }
        this.addOrReplaceNote(updatedNote) // optimistic
        await updateNoteAPI({
          surveyName,
          teamName,
          noteName,
          updatedNote
        })
      } catch (error) {
        this.addOrReplaceNote(currentNote)
        this.error = error
        throw error
      } finally {
        this.createOrUpdateNoteLoading = false
      }
    }
  }
})
